import React from "react";
import { Link } from "react-router-dom";
import { appHistory } from "@/router/history";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import PageHeader from "./PageHeader";
import { Button } from "../ui";
import { withAuthData } from "../../context/AuthContext";

interface NotFoundPageProps extends WithTranslation {
  userLoggedIn: boolean;
  customerLoggedIn: boolean;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ t, userLoggedIn, customerLoggedIn }) => {
  const isAuthenticated = userLoggedIn && customerLoggedIn;
  const goBack = () => {
    appHistory.back();
  };

  if (!isAuthenticated) {
    return (
      <div className="Page AuthPage NotFoundPageShell">
        <div className="Page-content AuthPage-content">
          <PageHeader
            kicker={t("topbar.platform_label")}
            title={t("not_found.title")}
            text={t("not_found.info_message")}
          />
          <div className="AuthPage-panel AuthPage-panel--compact">
            <div className="NotFoundPage-actions">
              <Button className="Button" onClick={goBack}>
                {t("common.button_back")}
              </Button>
              <Link className="Button AuthPage-secondaryAction" to={BASE_PATH + "/login"}>
                {t("login.label_connect")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="Page AccountPage NotFoundPageShell">
      <div className="Page-content AccountPage-content">
        <PageHeader
          breadcrumbs={[
            { label: t("navigation.label_home"), to: BASE_PATH + "/" },
            { label: t("not_found.title") },
          ]}
          kicker={t("profile.forbidden_kicker")}
          title={t("not_found.title")}
          text={t("not_found.info_message")}
          bannerClassName="AccountBanner"
        />
        <div className="AuthPage-panel AuthPage-panel--compact">
          <div className="NotFoundPage-actions">
            <Button className="Button" onClick={goBack}>
              {t("common.button_back")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withTranslation(), withAuthData)(NotFoundPage);
